import React from 'react';
import ReactDOM from 'react-dom/client';
import  { BrowserRouter } from "react-router-dom";
// import "uikit/dist/js/uikit.min.js";
import './assets/css/style.css';
// import './assets/css/uikit.min.css';
// import './assets/js/uikit.min.js';
// import './assets/js/uikit-icons.min.js';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
